// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1V3Qx","title":"BackImages_title__3F0eZ","images":"BackImages_images__YJoVI"};